/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import { threadContentMap } from '@/redux/selectors/pieveSelectors/baseSelectors.js';
import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';
import { shouldMaskThreadSurfaceContent as selectShouldMaskThreadSurfaceContent, threadSurfaceRouteHydrationState as selectThreadSurfaceRouteHydrationState } from '@/redux/selectors/uiSelectors.js';

export const isThreadSurfaceHydrationPending = createSelector([(_, threadId) => getNormalizedThreadId(threadId), selectShouldMaskThreadSurfaceContent], (threadId, shouldMaskThreadSurfaceContent) => {
  if (!threadId) {
    return false;
  }

  return shouldMaskThreadSurfaceContent === true;
});

export const shouldHideThreadSurfaceContent = createSelector([(_, threadId) => getNormalizedThreadId(threadId), threadContentMap, isThreadSurfaceHydrationPending, selectThreadSurfaceRouteHydrationState], (threadId, threadContentMapValue, isThreadSurfaceHydrationPendingValue, threadSurfaceRouteHydrationValue) => {
  if (!threadId) {
    return false;
  }

  const threadContent = threadContentMapValue?.[threadId] || null;
  const routeHydrationThreadId = getNormalizedThreadId(threadSurfaceRouteHydrationValue?.threadId);
  const isRouteHydrationTargetWithoutContent = routeHydrationThreadId === threadId && !threadContent;

  return Boolean(isThreadSurfaceHydrationPendingValue || isRouteHydrationTargetWithoutContent);
});
